/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentitySettingsListItem
 */
export interface IdentitySettingsListItem {
    /**
     * 
     * @type {string}
     * @memberof IdentitySettingsListItem
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentitySettingsListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof IdentitySettingsListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof IdentitySettingsListItem
     */
    distributionChannel?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof IdentitySettingsListItem
     */
    agency?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {number}
     * @memberof IdentitySettingsListItem
     */
    timeout?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IdentitySettingsListItem
     */
    allowEdit?: boolean;
}

export function IdentitySettingsListItemFromJSON(json: any): IdentitySettingsListItem {
    return IdentitySettingsListItemFromJSONTyped(json, false);
}

export function IdentitySettingsListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentitySettingsListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : Int32IdAndLabelFromJSON(json['distributionChannel']),
        'agency': !exists(json, 'agency') ? undefined : GuidIdCodeAndLabelFromJSON(json['agency']),
        'timeout': !exists(json, 'timeout') ? undefined : json['timeout'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function IdentitySettingsListItemToJSON(value?: IdentitySettingsListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannel': Int32IdAndLabelToJSON(value.distributionChannel),
        'agency': GuidIdCodeAndLabelToJSON(value.agency),
        'timeout': value.timeout,
        'allowEdit': value.allowEdit,
    };
}


